import React from 'react';
import { RATING_BANDS, VALUE_BUCKETS } from '../../utils/marketBuckets';

const SORT_OPTIONS = [
  { value: 'rating', label: 'Highest Rated' },
  { value: 'value', label: 'Best Value' },
  { value: 'underOwned', label: 'Under-Owned Strong Runners' },
  { value: 'popular', label: 'Most Popular' },
];

/**
 * Live Market filter bar — showdown, rating band, value badge, sort mode.
 * @param {Array} showdownOptions - [{ id, label }]
 */
export const MarketFilters = ({ showdownOptions, filters, onChange }) => {
  const set = (key) => (e) => onChange({ ...filters, [key]: e.target.value || null });

  return (
    <div className="mk-filters">
      <select className="mk-filter-select" value={filters.slateId || ''} onChange={set('slateId')} aria-label="Showdown">
        <option value="">All Showdowns</option>
        {showdownOptions.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
      </select>

      <select className="mk-filter-select" value={filters.ratingBand || ''} onChange={set('ratingBand')} aria-label="Rating band">
        <option value="">All Ratings</option>
        {RATING_BANDS.map(b => <option key={b} value={b}>{b}</option>)}
      </select>

      <select className="mk-filter-select" value={filters.valueLabel || ''} onChange={set('valueLabel')} aria-label="Value badge">
        <option value="">All Value Badges</option>
        {VALUE_BUCKETS.map(v => <option key={v} value={v}>{v}</option>)}
      </select>

      <select className="mk-filter-select mk-filter-select--sort" value={filters.sortBy || 'rating'} onChange={set('sortBy')} aria-label="Sort by">
        {SORT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
};

export default MarketFilters;
